module.exports = __webpack_public_path__ + "bradavice_1_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/dermatologie/bradavice_1_before_tn.jpg
// module id = 1398
// module chunks = 0